
import {
  getStationStatus,
  searchStationSummaryList,
  stationTaskGo,
  stationAllRead,
  stationRead
}
from '@/api/station-api.js'
import $utils from '@/utils/utils'
export default {
  namespaced: true,
  state: {
    stationSummaryResult: [],
  },
  getters: {
  },
  mutations: {
    setStationSummaryResult(state, stationSummaryResult) {
      state.stationSummaryResult = stationSummaryResult
    },
  },
  actions: {
    // 获取站内信未读数
    async getStationStatus(ctx, data) {
      return await getStationStatus(data)
    },
    // 跳转站内信任务
    async stationTaskGo(ctx, data) {
      const res = await stationTaskGo(data)
      return res
    },
    async searchStationSummaryList(ctx, data) {
      const res = await searchStationSummaryList(data)
      res.taskList = res.taskList || []
      res.noticeList = res.noticeList || []
      res.taskList.forEach(item => {
        item.createdTimeText = $utils.formatDate(item.createdTime, 'yyyy-MM-dd hh:mm')
      })
      res.noticeList.forEach(item => {
        item.createdTimeText = $utils.formatDate(item.createdTime, 'yyyy-MM-dd hh:mm')
      })
      ctx.commit('setStationSummaryResult', res)
      return res
    },
    // 消息全部已读
    async stationAllRead(ctx, data) {
      return await stationAllRead(data)
    },
    // 消息已读
    async stationRead(ctx, data) {
      return await stationRead(data)
    },
  }
}
